class Modal extends HTMLElement {
  constructor() {
    super();
    this.modalAttr = this.getAttribute("data-modal-index");
    this.triggers = document.querySelectorAll(
      `.js-modal-trigger[data-modal-index="${this.modalAttr}"]`
    );
    this.close = this.querySelector(".modal__close");
    this.body = document.querySelector('body');
    this.addEventListeners();
  }

  addEventListeners() {
    this.triggers.forEach((trigger) =>
      trigger.addEventListener("click", () => {
        this.classList.add("modal--active");
        this.body.classList.add('shadow');
      })
    );
    this.close.addEventListener("click", () => this.closeModal());
  }

  closeModal() {
    this.classList.remove("modal--active");
    this.body.classList.remove('shadow');
  }
}

customElements.define("modal-element", Modal);
